module.exports = __webpack_public_path__ + "dcos.logo.72c9a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/dcos/logo/dcos.logo.svg
// module id = 4092
// module chunks = 0